import React, { Children, createContext, createElement, useState } from 'react';
import Form from "rc-field-form";
import './index.scss';
export const ErrorMessageContext = createContext(null);
const ColorfulRcForm = props => {
    const { size, type, title, inlineNum, separate, cols, children, btn, ...otherProps } = props;
    const prefixCls = 'au-rc-form';
    const rcFormClass = [type, size, separate ? 'separate' : ''].filter(_ => !!_).map(_ => `${prefixCls}-${_}`).join(' ');
    const rcItemClass = [inlineNum].filter(_ => !!_).map(_ => `${prefixCls}-unit-${_}`).join(' ');
    const _otherProps = otherProps || {};
    const [form] = Form.useForm();
    const [errorMessage, setErrorMessage] = useState({});
    const onFinish = (values) => {
        setErrorMessage({});
        console.log('onFinish', values);
    };
    const onFinishFailed = (errorInfo) => {
        const { errorFields } = errorInfo;
        const obj = {};
        if (errorFields && errorFields.length > 0) {
            errorFields.forEach(err => {
                const key = err.name[0];
                const val = err.errors[0];
                obj[key] = val;
            });
        }
        setErrorMessage(obj);
        console.log('onFinishFailed', errorInfo);
    };
    let childrenToRender = children;
    if (cols && cols.length > 0) {
        childrenToRender = cols.map((option, i) => {
            return (createElement("div", { ...option, key: i, className: `au-rc-item-unit ${rcItemClass}` }, option?.children || ''));
        });
    }
    return (createElement("div", { className: `${prefixCls} ${rcFormClass}`, ..._otherProps },
        createElement(ErrorMessageContext.Provider, { value: { errorMessage } },
            createElement("h3", null, title || '请添加表单配置搭建表单页面'),
            createElement(Form, { form: form, onFinish: onFinish, onFinishFailed: onFinishFailed },
                createElement("div", { className: "au-rc-form-list" }, Children.map(childrenToRender, (child, index) => {
                    return React.cloneElement(child, {
                        index,
                    });
                })),
                btn && createElement("div", { className: "au-rc-form-btns" }, btn)))));
};
ColorfulRcForm.displayName = 'ColorfulRcForm';
export default ColorfulRcForm;
